import emailValidator from "email-validator";

export function email(value) {

  let empty = false;
  let valid = false;

  if (!value || value.length === 0 || value.trim().length === 0) {
    empty = true;
  }
  else {
    valid = emailValidator.validate(value);
  }

  return new Promise((resolve, reject) => {
    resolve({ valid, empty });
  });
}

export function password(value) {

  let empty = false;
  let valid = false;

  if(!value || value.length === 0) {
    empty = true;
  }
  else {
    valid = true;
  }

  return new Promise((resolve, reject) => {
    resolve({ valid, empty });
  });
}

export function nonEmpty(value) {

  let empty = false;
  let valid = false;
  value = (value && typeof value === 'string') ? value.trim() : value;

  if(!value || value.length === 0) {
    empty = true;
  }
  else {
    valid = true;
  }

  return new Promise((resolve, reject) => {
    resolve({ valid, empty });
  });
}

export function gender(value) {
    
  let empty = false;
  let valid = false;

  if(!value || value.length === 0) {
    empty = true;
  }
  else{
    if(value === "MALE" || value === "FEMALE") {
      valid = true;
    }
  }

  return new Promise((resolve, reject) => {
    resolve({ valid, empty });
  });
}

export function float(value) {

  let empty = false;
  let valid = false;

  if(!value || value.length === 0) {
    empty = true;
  }
  else {
    if(isFloat(value)) {
      valid = true;
    }
  }

  return new Promise((resolve, reject) => {
    resolve({valid, empty});
  });
}

export function positiveInt(value) {

  let empty = false;
  let valid = false;

  if(!value || value.length === 0) {
      empty = true;
  }
  else {
    if (!isNaN(value) && value > 0) {
      valid = true;
    }
  }

  return new Promise((resolve, reject) => {
    resolve({valid, empty});
  });
}

function isFloat(n) {
  return parseFloat(n.match(/^-?\d*(\.\d+)?$/)) > 0;
}



// WEBPACK FOOTER //
// ./src/lib/validators.js